import React, { HTMLAttributes, Suspense, useState } from 'react';
import classNames from 'classnames';

import Button from 'atomic/button/button';
import Svg from 'atomic/svg/svg';
import login from 'assets/icons/login.svg';

import './cabinet.scss';
import LoadingOverlay from 'atomic/loading-overlay';
import JoinUsModal from 'components/join-us/join-us';

const Cabinet: React.FC<HTMLAttributes<HTMLElement>> = ({ className, ...props }) => {
    const [showJoinUsModal, setShowJoinUsModal] = useState(false);

    const cabinetClasses = classNames(className, 'cabinet');

    return (
        <div className={cabinetClasses} {...props}>
            <Button className="cabinet__register-link" wrapper={true} onClick={(): void => setShowJoinUsModal(true)}>
                + Dodaj
            </Button>
            <Button className="cabinet__login-button" wrapper={true}>
                <Svg className="cabinet__login-icon" path={login} width={36}/>
                <div className="cabinet__dropdown-list">
                    <a className="cabinet__dropdown-list-item" title="Zaloguj się jako firma" href="https://panel.opineo.pl/">
                        Zaloguj jako firma
                    </a>
                </div>
            </Button>
            {showJoinUsModal && (
                <Suspense fallback={<LoadingOverlay/>}>
                    <JoinUsModal onClose={(): void => setShowJoinUsModal(false)}/>
                </Suspense>
            )}
        </div>
    );
};

export default Cabinet;
